import type { TranslationKey } from '@/i18n/translations'

export interface NavItem {
  href: string
  labelKey: TranslationKey
  /** lucide-react icon name, used only in the mobile overlay nav (matches Stitch's per-item icons) */
  icon: 'briefcase' | 'layout-grid' | 'star' | 'user' | 'help-circle' | 'newspaper' | 'mail'
}

// Anchors match the current live site's section ids exactly (#usluge, #portfolio,
// #recenzije, #o-meni, #faq, #kontakt) so existing deep links keep working —
// see master prompt §5.1 "Preserve existing anchors so old links continue working."
// Blog is the one exception: Phase 5 gave it real routed pages instead of an
// anchor section, so its href is a path ('/blog'), not a hash. NavLink (see
// DesktopNav/MobileNav) resolves hash items to `/#hash` and leaves path items
// (starting with '/') as-is, so this array can mix both kinds safely.
export const navItems: NavItem[] = [
  { href: '#usluge', labelKey: 'nav-services', icon: 'briefcase' },
  { href: '#portfolio', labelKey: 'nav-portfolio', icon: 'layout-grid' },
  { href: '#recenzije', labelKey: 'nav-reviews', icon: 'star' },
  { href: '/o-meni', labelKey: 'nav-about', icon: 'user' },
  { href: '#faq', labelKey: 'nav-faq', icon: 'help-circle' },
  { href: '/blog', labelKey: 'nav-blog', icon: 'newspaper' },
  { href: '/kontakt', labelKey: 'nav-contact', icon: 'mail' },
]
